// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"e70ad11a","355":"e94f5c12","370":"b308e9e6","664":"12261935","674":"3b7836eb","984":"10ceef0d"}[chunkId] + ".chunk.css";
};